import platformService from '@/data/services/platform.service';
import usePlatformStore from '@/data/stores/platform.store';

export const usePlatform = () => {
  const {
    platforms,
    selectedPlatform,
    isLoading,
    error,
    setPlatforms,
    setSelectedPlatform,
    setLoading,
    setError,
    hasPlatform,
  } = usePlatformStore();

  const loadPlatforms = async () => {
    setLoading(true);
    try {
      const platformsData = await platformService.getPlatforms();

      setPlatforms(platformsData);
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : 'Failed to load platforms';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return {
    platforms,
    selectedPlatform,
    isLoading,
    error,
    setSelectedPlatform,
    loadPlatforms,
    hasPlatform,
  };
};
